import * as THREE from 'three';

declare module 'three' {
  interface OrthographicCamera {
    zoomTo(node: THREE.Object3D, factor?: number): void;
  }
}

THREE.OrthographicCamera.prototype.zoomTo = function (
  this: THREE.OrthographicCamera,
  node: THREE.Object3D,
  _factor = 1,
): void {
  if (!(node as any).geometry && !(node as any).boundingBox) {
    return;
  }

  // TODO: implement orthographic zoom-to logic

  this.updateProjectionMatrix();
};
